import React, { useEffect, useMemo } from 'react';
import EditLargeCardFormik from '../main/edit-large-card-formik';
import MansionToOperationalContactAssignmentsForm, {
    OperationalContactAssignments,
} from '../operational-contacts/mansion-to-operational-contact-assignments-form';
import { usePbDispatch, usePbSelector } from '../../store/pbStoreHooks';
import { RequestStatus } from '../../store/network/managedRequest';
import {
    AssignOperationalContactsToMansion,
    GetOperationalContacts,
} from '../../store/operationalContactsSlice';
import useTranslate from '../useTranslate';
import useFeatureAccess from '../../util/useFeatureAccess';
import { Link } from 'react-router';
import { Button } from 'react-bootstrap';
import { PbRequest } from '../../store/pbRequest';

interface Props {
    mansionId: number;
}

function ObjectOperationalContactsCard(props: Readonly<Props>) {
    const strings = useTranslate('MansionToOperationalContactAssign');
    const dispatch = usePbDispatch();
    const getOperationalContacts = usePbSelector(
        (state) => state.pbRequest[PbRequest.GET_OPERATIONAL_CONTACTS]
    );
    const getOperationalContactsData = usePbSelector(
        (state) => state.operationalContacts.operationalContacts
    );

    useEffect(() => {
        if (getOperationalContacts.status === RequestStatus.INITIAL) {
            dispatch(GetOperationalContacts());
        }
    }, [getOperationalContacts.status]);
    const selectedIds = useMemo(
        () =>
            new Set(
                getOperationalContactsData?.list
                    ?.filter((it) =>
                        it.mansions.find(
                            (m) => m.mansion_id === props.mansionId
                        )
                    )
                    ?.map((it) => it.operational_contact_id) ?? ([] as number[])
            ),
        [getOperationalContactsData, props.mansionId]
    );
    const selectedPartner = usePbSelector(
        (state) => state.partnerManager.selectedPartner
    );
    const { canWriteFeature } = useFeatureAccess(selectedPartner);
    const mayAddContact = canWriteFeature('GENERAL_OPERATIONAL_CONTACTS');

    const initialValues: OperationalContactAssignments = {
        operationalContactIds: Array.from(selectedIds),
    };

    return (
        <EditLargeCardFormik
            title={strings.title}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            error={getOperationalContacts.status === RequestStatus.FAILURE}
            enableReinitialize
            disabled={!getOperationalContactsData?.list?.length}
        >
            {(formProps) => (
                <>
                    <MansionToOperationalContactAssignmentsForm
                        operationalContacts={getOperationalContactsData?.list}
                        disabled={!formProps.active}
                    />
                    {mayAddContact && !formProps.active && (
                        <div className={'mt-2 mb-2 pull-right'}>
                            <Link
                                className="icon icon-wew-admin-add icon-sm"
                                to={'/operational-contacts/create'}
                            >
                                <Button className={'btn btn-link btn-action'}>
                                    {' '}
                                    {strings.actionCreate}
                                </Button>
                            </Link>
                        </div>
                    )}
                </>
            )}
        </EditLargeCardFormik>
    );

    function handleSubmit(values: OperationalContactAssignments) {
        dispatch(
            AssignOperationalContactsToMansion(
                values.operationalContactIds,
                props.mansionId
            )
        );
    }
}

export default ObjectOperationalContactsCard;
